import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;
const authApi = axios.create({ baseURL: API, timeout: 15000, withCredentials: true });

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const authLogin = (email, password) =>
    authApi.post("/login", { email, password }).then((r) => r.data);
export const authLogout = () => authApi.post("/logout").then((r) => r.data);
export const authMe = () => authApi.get("/me").then((r) => r.data);
export const authForgot = (email) =>
    authApi.post("/forgot-password", { email }).then((r) => r.data);
export const authReset = (token, new_password) =>
    authApi.post("/reset-password", { token, new_password }).then((r) => r.data);
export const requestLiveOtp = (bot) =>
    authApi.post("/live-otp/request", { bot }).then((r) => r.data);
export const verifyLiveOtp = (bot, code) =>
    authApi.post("/live-otp/verify", { bot, code }).then((r) => r.data);

// ---- API-key management (OTP-gated) ----
const KEYS = `${process.env.REACT_APP_BACKEND_URL}/api/keys`;
const keysApi = axios.create({ baseURL: KEYS, timeout: 15000, withCredentials: true });

export const getApiKeys = (bot) =>
    keysApi.get(`/${bot}`).then((r) => r.data);
export const requestKeyOtp = (bot) =>
    keysApi.post(`/${bot}/otp/request`).then((r) => r.data);
export const saveApiKeys = (bot, payload) =>
    keysApi.post(`/${bot}/save`, payload).then((r) => r.data);
